import React, { FC, useEffect, useState } from 'react';
import apiRoutes from '../../../config/api/routes';
import { settingsMapper } from '../../../config/api/models';
import { useCachedFetch } from '../../shared';
import { SettingsContext } from './SettingsContext';
import { Settings } from '../../../config/api/models/Settings';

interface ISettingsProvider {
  children: React.ReactNode;
}

export const SettingsProvider: FC<ISettingsProvider> = ({ children }) => {
  const [settings, setSettings] = useState<Settings | undefined>();

  const settingsFetch = useCachedFetch(['settings'], apiRoutes.settings(), {
    mapper: settingsMapper,
    options: {
      enabled: settings == null,
    },
  });

  useEffect(() => {
    if (settingsFetch.data != null && settings == null) {
      setSettings(settingsFetch.data);
    }
  }, [settingsFetch, settings]);

  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
};
